import {h, JSX} from 'preact'
import {Modal} from './Modal'
import classNames from 'classnames';
import {TextField, TextFieldProps} from './TextField';

export interface PartialPaymentModalProps {
    title: string;
    show: boolean;
    isSaveDisabled?: boolean;
    toggleModal: () => void;
    onSubmit?: () => void;
    submitLabel?: string;
    closeLabel?: string;
    amountField: TextFieldProps;
}

export const PartialPaymentModal = (props: PartialPaymentModalProps): JSX.Element => (
    <Modal
        show={props.show}
        toggleModal={props.toggleModal}
        title={props.title}
        hasCloseButton
    >
        {props.amountField && (
            <div class="px-8 py-6">
                <TextField {...props.amountField}/>
            </div>
        )}
        <div class='flex shrink justify-end items-center border-t px-8 py-6'>
            <div class='flex gap-2.5'>
                {props.closeLabel && (
                    <button onClick={props.toggleModal} class='btn btn-border p-4 text-base leading-[14px]'>
                        {props.closeLabel}
                    </button>
                )}
                {props.submitLabel && (
                    <button
                        onClick={props.onSubmit}
                        disabled={props.isSaveDisabled}
                        class={classNames(
                            'btn p-4 text-base leading-[14px]',
                            props.isSaveDisabled ? 'btn-disabled' : 'btn-light-blue'
                        )}
                    >
                        {props.submitLabel}
                    </button>
                )}
            </div>
        </div>
    </Modal>
);
